import { Box, IconButton, Typography } from '@mui/material'
import toast from 'react-hot-toast'

import { ExclusionRuleToast } from './createExclusionRule.styles'

export const showExclusionRuleDeletedToast = (durationMs = 5000) =>
  toast.custom(
    (t) => (
      <ExclusionRuleToast visible={t.visible} durationMs={durationMs}>
        <Box className="toast-row">
          <Box className="toast-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 9V15M15 12H9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                stroke="#E9E0E4"
                strokeWidth="1.44"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Box>
          <Typography component="p" className="toast-text">
            Exclusion rules were deleted. Records affected by these rules will be restored and included in calculations
            again.
          </Typography>
          <IconButton className="toast-close" onClick={() => toast.dismiss(t.id)} aria-label="Dismiss">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5 15L15 5M5 5L15 15"
                stroke="#D0C3CC"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </IconButton>
        </Box>
        <Box className="toast-progress" />
      </ExclusionRuleToast>
    ),
    {
      duration: durationMs,
      style: {
        background: 'transparent',
        padding: 0,
        boxShadow: 'none',
        minHeight: 'auto',
        width: 'auto'
      }
    }
  )
